function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import OtpModal from "../OtpModal";

/**
 * AccountRestorationModal - Presentational modal for restoring a closed account during grace period.
 *
 * Flow:
 * 1. IDENTIFY: Displays pre-filled mobile/email (or input) -> User requests restore OTP.
 * 2. OTP: Reuses OtpModal to verify OTP -> Submits restoration call.
 * 3. SUCCESS: Shows restoration confirmation -> Redirects to login.
 *
 * Props:
 * - open: boolean controlling visibility
 * - onClose: () => void, called when user dismisses modal
 * - initialIdentifier: string, pre-filled phone number or requestUuid
 * - onRequestCancelOtp: async (identifier) => void, requests restore OTP
 * - onConfirmRestore: async (identifier, otp) => void, submits restoration with OTP
 * - onSuccess: () => void, called when restoration completes to trigger login redirect
 * - requestOtpLoading: boolean
 * - confirmLoading: boolean
 * - errorMessage: string
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var AccountRestorationModal = function AccountRestorationModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    _ref$initialIdentifie = _ref.initialIdentifier,
    initialIdentifier = _ref$initialIdentifie === void 0 ? "" : _ref$initialIdentifie,
    onRequestCancelOtp = _ref.onRequestCancelOtp,
    onConfirmRestore = _ref.onConfirmRestore,
    onSuccess = _ref.onSuccess,
    _ref$requestOtpLoadin = _ref.requestOtpLoading,
    requestOtpLoading = _ref$requestOtpLoadin === void 0 ? false : _ref$requestOtpLoadin,
    _ref$confirmLoading = _ref.confirmLoading,
    confirmLoading = _ref$confirmLoading === void 0 ? false : _ref$confirmLoading,
    errorMessage = _ref.errorMessage;
  var _useState = useState("IDENTIFY"),
    _useState2 = _slicedToArray(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1]; // "IDENTIFY" | "OTP" | "SUCCESS"
  var _useState3 = useState(initialIdentifier),
    _useState4 = _slicedToArray(_useState3, 2),
    identifier = _useState4[0],
    setIdentifier = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    localError = _useState6[0],
    setLocalError = _useState6[1];
  if (!open) return null;
  var handleReset = function handleReset() {
    setStep("IDENTIFY");
    setLocalError("");
    onClose();
  };
  var handleRequestOtp = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (identifier.trim()) {
              _context.n = 1;
              break;
            }
            setLocalError("Please enter your registered mobile number or request ID.");
            return _context.a(2);
          case 1:
            setLocalError("");
            _context.p = 2;
            _context.n = 3;
            return onRequestCancelOtp(identifier.trim());
          case 3:
            setStep("OTP");
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            setLocalError((_t === null || _t === void 0 ? void 0 : _t.message) || "Failed to send restoration OTP. Please check your details.");
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[2, 4]]);
    }));
    return function handleRequestOtp() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleVerifyOtp = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(otp) {
      var _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            setLocalError("");
            _context2.p = 1;
            _context2.n = 2;
            return onConfirmRestore(identifier.trim(), otp);
          case 2:
            setStep("SUCCESS");
            _context2.n = 4;
            break;
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            setLocalError((_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || "Account restoration failed. Please try again.");
          case 4:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function handleVerifyOtp(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  if (step === "OTP") {
    return /*#__PURE__*/_jsx(OtpModal, {
      open: true,
      onClose: function onClose() {
        return setStep("IDENTIFY");
      },
      title: "Account Restoration Verification",
      description: "Enter the OTP sent to your registered contact (".concat(identifier, ") to restore your account."),
      onResend: function onResend() {
        return onRequestCancelOtp(identifier.trim());
      },
      onVerify: handleVerifyOtp,
      resendLoading: requestOtpLoading,
      verifyLoading: confirmLoading,
      errorMessage: localError || errorMessage
    });
  }
  if (step === "SUCCESS") {
    return /*#__PURE__*/_jsx("div", {
      className: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4",
      children: /*#__PURE__*/_jsxs("div", {
        className: "w-full max-w-sm rounded-lg bg-white p-6 shadow-xl text-center",
        children: [/*#__PURE__*/_jsx("div", {
          className: "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100",
          children: /*#__PURE__*/_jsx("svg", {
            className: "h-6 w-6 text-green-600",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: /*#__PURE__*/_jsx("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: "2",
              d: "M5 13l4 4L19 7"
            })
          })
        }), /*#__PURE__*/_jsx("h2", {
          className: "mt-4 text-lg font-semibold text-gray-900",
          children: "Account Restored!"
        }), /*#__PURE__*/_jsx("p", {
          className: "mt-2 text-sm text-gray-600",
          children: "Your account closure request has been cancelled and your profile is fully restored."
        }), /*#__PURE__*/_jsx("div", {
          className: "mt-6",
          children: /*#__PURE__*/_jsx("button", {
            onClick: function onClick() {
              handleReset();
              if (onSuccess) onSuccess();
            },
            className: "w-full rounded-md bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-700",
            children: "Proceed to Login"
          })
        })]
      })
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4",
    children: /*#__PURE__*/_jsxs("div", {
      className: "w-full max-w-md rounded-lg bg-white p-6 shadow-xl",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-between border-b pb-3",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "text-xl font-semibold text-gray-900",
          children: "Restore Your Account"
        }), /*#__PURE__*/_jsx("button", {
          onClick: handleReset,
          className: "text-gray-400 hover:text-gray-600 text-xl font-bold",
          "aria-label": "Close",
          children: "\xD7"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "mt-4 space-y-3 text-sm text-gray-600",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "rounded-md bg-blue-50 p-3 text-blue-800 border border-blue-200",
          children: [/*#__PURE__*/_jsx("p", {
            className: "font-semibold",
            children: "\u2139\uFE0F Account Pending Deletion"
          }), /*#__PURE__*/_jsx("p", {
            className: "mt-1",
            children: "Your account is currently within its 7-day grace period. You can restore your account and reactivate your profile now."
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "pt-2",
          children: [/*#__PURE__*/_jsx("label", {
            className: "block text-xs font-medium text-gray-700 mb-1",
            children: "Registered Mobile Number or Request ID:"
          }), /*#__PURE__*/_jsx("input", {
            type: "text",
            value: identifier,
            onChange: function onChange(e) {
              return setIdentifier(e.target.value);
            },
            placeholder: "e.g. 9876543210 or request-uuid",
            className: "w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none"
          })]
        })]
      }), (localError || errorMessage) && /*#__PURE__*/_jsx("p", {
        className: "mt-3 text-sm text-red-600",
        children: localError || errorMessage
      }), /*#__PURE__*/_jsxs("div", {
        className: "mt-6 flex items-center justify-end gap-3",
        children: [/*#__PURE__*/_jsx("button", {
          onClick: handleReset,
          className: "rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50",
          children: "Cancel"
        }), /*#__PURE__*/_jsx("button", {
          onClick: handleRequestOtp,
          disabled: requestOtpLoading || !identifier.trim(),
          className: "rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed",
          children: requestOtpLoading ? "Sending OTP..." : "Send Restore OTP"
        })]
      })]
    })
  });
};
export default AccountRestorationModal;